import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { MODAL_TOKEN, ModalProvider, userTrophiesMapper, UserTrophyModel } from '@core';
import { AppTrophyType } from '@core-http';
import { OrIconComponent } from '@ui-components';

@Component({
  selector: 'lib-new-trophy-recieved-modal',
  templateUrl: './new-trophy-recieved-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OrIconComponent],
  standalone: true
})
export class NewTrophyRecievedModalComponent {
  @Input() trophyType!: AppTrophyType;

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  public trophyMapper: Record<AppTrophyType, UserTrophyModel> = userTrophiesMapper;

  close(): void {
    this.modalProvider.dismissModal$();
  }
}
